/**
 * Date-of-service comparison helpers for CPT sibling propagation.
 * @module isLaterDateOfService
 */
import { toTime } from "../../../../../context/utils/siblingOrderFilter/dateUtils";

/**
 * Returns whether the target date of service is strictly after the parent DOS.
 *
 * @param parentDateOfService - Parent order date of service
 * @param targetDateOfService - Sibling or target order date of service
 * @returns True when target DOS is later than parent; false when equal, earlier,
 *   or either value is missing or unparseable
 */
export const isLaterDateOfService = (
  parentDateOfService?: string,
  targetDateOfService?: string,
): boolean => {
  const parentTime = toTime(parentDateOfService);
  const targetTime = toTime(targetDateOfService);
  if (parentTime === null || targetTime === null) {
    return false;
  }
  return targetTime > parentTime;
};
